import React from "react";
// import ReactDOM from "react-dom";
import "./Utils/checkoutAutoLoginBootstrap";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./i18n";
import reloadOnceForChunkError from "./Utils/chunkReloadGuard";
import { captureAppError, flushErrorReports } from "./Utils/errorReporting";

import { createRoot } from "react-dom/client";

// Suppress noisy ResizeObserver loop errors that surface in some browsers
// when layout changes during measurement. This keeps the console clean while
// we refine layouts.
const resizeObserverPattern =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;
const resizeObserverErrorHandler = (event) => {
  const message =
    event?.message ||
    event?.error?.message ||
    event?.reason?.message ||
    event?.reason ||
    "";
  if (typeof message === "string" && resizeObserverPattern.test(message)) {
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
  }
};
window.addEventListener("error", resizeObserverErrorHandler, true);
window.addEventListener("unhandledrejection", resizeObserverErrorHandler, true);
window.onerror = (message) => {
  if (typeof message === "string" && resizeObserverPattern.test(message)) {
    return true; // prevent default handling
  }
  return undefined;
};
window.onunhandledrejection = (event) => {
  const reason = event?.reason?.message || event?.reason || "";
  if (typeof reason === "string" && resizeObserverPattern.test(reason)) {
    return true;
  }
  return undefined;
};

const chunkErrorHandler = (event) => {
  const error = event?.error || event?.reason || event;
  if (
    reloadOnceForChunkError(error, () => {
      captureAppError(error, { source: "global_chunk_handler" });
      return flushErrorReports();
    })
  ) {
    event?.stopImmediatePropagation?.();
    event?.preventDefault?.();
    return;
  }
};
window.addEventListener("error", chunkErrorHandler);
window.addEventListener("unhandledrejection", chunkErrorHandler);

// Silence React error overlay noise for ResizeObserver warnings in dev
const originalConsoleError = console.error;
const isDevelopment = process.env.NODE_ENV === "development";
const dndDefaultPropsWarningPattern =
  /Support for defaultProps will be removed from memo components|Connect\(Droppable\)/i;
console.error = (...args) => {
  if (
    isDevelopment &&
    args.length &&
    typeof args[0] === "string" &&
    dndDefaultPropsWarningPattern.test(args[0])
  ) {
    return;
  }
  if (
    args.length &&
    typeof args[0] === "string" &&
    resizeObserverPattern.test(args[0])
  ) {
    return;
  }
  originalConsoleError.apply(console, args);
};

// Patch ResizeObserver to batch callbacks in rAF, reducing loop-limit errors
if (
  typeof window !== "undefined" &&
  typeof window.ResizeObserver !== "undefined"
) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      let rAFScheduled = false;
      let lastEntries = [];
      super((entries, observer) => {
        lastEntries = entries;
        if (rAFScheduled) return;
        rAFScheduled = true;
        requestAnimationFrame(() => {
          rAFScheduled = false;
          callback(lastEntries, observer);
        });
      });
    }
  };
}

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

// ReactDOM.render(
//   <App />,

//   document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
